import { CwsA, CwsGridCol, CwsGridRow, CwsP, CwsSpan } from '@components/cws'
import type { FC } from 'react'
import { Clubone as CluboneImage } from './assets'
import { useTranslate } from '@hooks/useTranslation'
import { useRouter } from 'next/router'

interface CoLoginBannerProps {
  onPaymentView?: boolean
}

export const CoLoginBanner: FC<CoLoginBannerProps> = ({ onPaymentView }) => {
  const { locale } = useRouter()
  const { translate } = useTranslate()

  const handleSignInClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    window.scrollTo(0, 0)
    window.SSO.open()
  }

  const clubOneUrls: { [key: string]: string } = {
    et: 'https://clubone.tallink.com/et',
    fi: 'https://clubone.tallink.com/fi',
    sv: 'https://clubone.tallink.com/sv',
    en: 'https://clubone.tallink.com/',
    ru: 'https://clubone.tallink.com/ru',
    lv: 'https://clubone.tallink.com/lv',
    lt: 'https://clubone.tallink.com/',
  }

  const clubOneUrl = clubOneUrls[locale || 'et']

  const discountText = translate('w2.discount.text', {
    joinCubOne: `<a class="cws-a cws-a--theme-white cws-a--size-tiny cws-a--inline cws-a--color-dark-grey" rel="noopener noreferrer"  href="${clubOneUrl}">${translate(
      'w2.join.club.one'
    )}</a>`,
  })

  return (
    <CwsGridRow>
      <CwsGridCol col="12">
        <CwsGridRow verticalAlign="center" noGutter>
          <CwsGridCol col="auto">
            <CluboneImage />
          </CwsGridCol>
          <CwsGridCol col="fluid">
            <CwsP size="small" className="cws-pl-xs cws-m-0">
              <CwsA
                class="cws-a cws-a--theme-white cws-a--size-tiny cws-a--inline cws-a--color-dark-grey"
                rel="noopener noreferrer"
                href="/"
                onClick={handleSignInClick}
              >
                {translate('w2.sign.in')}
              </CwsA>{' '}
              <CwsSpan dangerouslySetInnerHTML={{ __html: discountText }} />
            </CwsP>
          </CwsGridCol>
        </CwsGridRow>
      </CwsGridCol>
    </CwsGridRow>
  )
}

export default CoLoginBanner
